import { render, staticRenderFns } from "./StockCompany.vue?vue&type=template&id=2d37df70&scoped=true"
import script from "./StockCompany.vue?vue&type=script&lang=js"
export * from "./StockCompany.vue?vue&type=script&lang=js"
import style0 from "./StockCompany.vue?vue&type=style&index=0&id=2d37df70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d37df70",
  null
  
)

export default component.exports